import React, { useState } from 'react';
import { BaseConfigProps, commonStyles } from '../shared/ConfigFormHelpers';

const SwitchConfig: React.FC<BaseConfigProps> = ({ node, updateConfig }) => {
  const [newCaseName, setNewCaseName] = useState('');
  const [newCaseValue, setNewCaseValue] = useState('');
  
  const cases = node.data.config.cases || [];
  const switchValue = node.data.config.switchValue || '';
  const defaultCase = node.data.config.defaultCase || 'default';

  const addCase = () => {
    if (newCaseName && newCaseValue) {
      const updatedCases = [...cases, { name: newCaseName, value: newCaseValue }];
      updateConfig('cases', updatedCases);
      setNewCaseName('');
      setNewCaseValue('');
    }
  };

  const removeCase = (index: number) => {
    const updatedCases = cases.filter((_: any, i: number) => i !== index);
    updateConfig('cases', updatedCases);
  };

  return (
    <div className="space-y-4">
      <div>
        <label className={commonStyles.label}>
          Switch értéke
        </label>
        <input
          type="text"
          value={switchValue}
          onChange={(e) => updateConfig('switchValue', e.target.value)}
          className={commonStyles.input}
          placeholder="{{variable}} vagy fix érték"
        />
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
          Ez az érték alapján dönti el, melyik ágra menjen
        </p>
      </div>

      <div>
        <label className={commonStyles.label}>
          Esetek (Cases)
        </label>
        
        {cases.length > 0 && (
          <div className="space-y-2 mb-3">
            {cases.map((caseItem: any, index: number) => (
              <div key={index} className="flex items-center space-x-2 p-2 bg-gray-50 dark:bg-gray-800 rounded-md">
                <div className="flex-1">
                  <div className="text-sm font-medium text-gray-900 dark:text-white">
                    {caseItem.name}
                  </div>
                  <div className="text-xs text-gray-500 dark:text-gray-400">
                    Érték: {caseItem.value}
                  </div>
                </div>
                <button
                  onClick={() => removeCase(index)}
                  className="text-red-500 hover:text-red-700 text-sm"
                >
                  ✕
                </button>
              </div>
            ))}
          </div>
        )}

        <div className="border border-gray-300 dark:border-gray-600 rounded-md p-3 space-y-2">
          <div className="text-sm font-medium text-gray-700 dark:text-gray-300">
            Új eset hozzáadása
          </div>
          <div className="grid grid-cols-2 gap-2">
            <input
              type="text"
              value={newCaseName}
              onChange={(e) => setNewCaseName(e.target.value)}
              className={commonStyles.input}
              placeholder="Eset neve"
            />
            <input
              type="text"
              value={newCaseValue}
              onChange={(e) => setNewCaseValue(e.target.value)}
              className={commonStyles.input}
              placeholder="Érték"
            />
          </div>
          <button
            onClick={addCase}
            disabled={!newCaseName || !newCaseValue}
            className="w-full px-3 py-2 bg-primary-500 text-white rounded-md text-sm hover:bg-primary-600 disabled:bg-gray-300 disabled:cursor-not-allowed"
          >
            Eset hozzáadása
          </button>
        </div>
      </div>

      <div>
        <label className={commonStyles.label}>
          Alapértelmezett eset
        </label>
        <input
          type="text"
          value={defaultCase}
          onChange={(e) => updateConfig('defaultCase', e.target.value)}
          className={commonStyles.input}
          placeholder="default"
        />
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
          Ha egyik eset sem illeszkedik, erre az ágra megy
        </p>
      </div>

      <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-md p-3">
        <div className="text-xs text-blue-700 dark:text-blue-300">
          <strong>Működés:</strong>
          <ol className="list-decimal list-inside mt-1 space-y-1">
            <li>A Switch értéke összehasonlításra kerül minden esettel</li>
            <li>Ha talál egyezést, az adott ágra irányít</li>
            <li>Ha nincs egyezés, az alapértelmezett ágra megy</li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default SwitchConfig;
